import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import testimonial1 from "../asset/Home/testimonial1.svg";
import testimonial2 from "../asset/Home/testimonial2.svg";
import testimonial3 from "../asset/Home/testimonial3.svg";
import starRating from "../asset/Home/starRating.svg"
import commaImage from "../asset/Home/commaImage.svg";
const testimonials = [
  {
    image: testimonial1,
     name: "-Dhruv Kapoor,",
    role: "Customer Success Lead",
    review:
      "We deployed our AI sales agent in just a few minutes, and it immediately started handling lead qualification and common objections. Our team now spends less time on repetitive calls and more time closing high-value opportunities.",
  },
  {
    image: testimonial2,
   name: "-Sarah",
    role: "Head of Sales",
    review:
      "Our support team now handles far more customer conversations without increasing headcount. The CSM AI agent responds naturally, understands our knowledge base, and provides accurate answers around the clock. Customers appreciate the quick responses, and our team can focus on more complex issues.",
  },
  {
    image: testimonial3,
    name: "-Rahul Sharma, ",
    role: "HR Manager",
    review:
      "Employee screening used to consume hours every week. With Craft Your Agent, our AI recruiter conducts first-round interviews, answers candidate questions, and shares consistent information throughout the hiring process. It's transformed the way we hire and engage candidates",  },
];
function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const TOTAL_TESTIMONIALS = 3;
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => {
        if (prev === TOTAL_TESTIMONIALS - 1) {
          return 0;
        }
        return prev + 1;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  return (
    <section
   id="testimonials"
      className="py-16 md:py-20 lg:py-28 px-4 sm:px-6 bg-white"
      style={{ zoom: "0.84" }}
    >
      <div className="max-w-[1180px] mx-auto">
        {/* Badge */}

        <div className="flex justify-center">
          <span
            className="
							bg-[#FFE4DE]
							text-[#F06A50]
							font-semibold
							font-prompt
							text-sm md:text-base lg:text-[18px]
							px-4
							py-2
							rounded-md
						"
          >
            Testimonials
          </span>
        </div>

        {/* Heading */}

        <h2
          className="
						mt-5
						text-center
						font-prompt
						font-bold
						text-[#0C0200]
						text-[32px]
sm:text-[40px]
md:text-[48px]
lg:text-[56px]
						leading-[1.1]
					"
        >
          Results That Speak for Themselves.
        </h2>

        {/* Description */}

        {/* <p
          className="
						mt-4
						max-w-[980px]
px-2
text-[14px]
sm:text-[15px]
lg:text-[16px]
						mx-auto
						text-center
						font-jakarta
						text-[#0C0200]
					
						leading-[1.8]
						font-jakarta
					"
        >
          All the Lorem Ipsum generators on the Internet tend to repeat
          predefined chunks as necessary, making this the first true generator
          on the Internet. It uses a dictionary of over 200 Latin words,
          combined with a handful of model sentence structures.
        </p> */}

        {/* Content */}

        <div
          className="
		mt-10
		md:mt-16

		flex
		flex-col
		lg:flex-row

		gap-6
		items-start
	"
        >
          {/* Left Images */}

          <div
            className="
    w-full
    lg:w-[260px]

    grid
    grid-cols-3
    lg:grid-cols-1

    gap-3
    lg:gap-4
  "
          >
            {testimonials.map((item, index) => (
              <motion.img
                key={index}
                src={item.image}
                alt=""
                animate={{
                  scale: activeIndex === index ? 1.05 : 0.9,
                  opacity: activeIndex === index ? 1 : 0.55,
                }}
                transition={{
                  duration: 0.45,
                }}
                className={`
        w-full
        object-cover
        rounded-[18px]
        border-2

        ${
          index === 1
            ? "h-[120px] sm:h-[150px] lg:h-[190px]"
            : "h-[90px] sm:h-[110px] lg:h-[130px]"
        }

        ${activeIndex === index ? "border-transparent" : "border-transparent"}
      `}
              />
            ))}
          </div>

          {/* Testimonial Card */}

          <div
            className="
	
flex-1

bg-[#FBFBFB]
border
border-[#E4E0DC]

rounded-[20px]

p-5
sm:p-7
lg:p-[34px]

relative
overflow-hidden

h-[360px]
sm:h-[420px]
lg:h-[470px]

flex
flex-col
"
          >
            {/* Quote */}

            <img
              src={commaImage}
              alt=""
              className="
    absolute

    -top-1
    right-12

    sm:top-6
    sm:right-6
		md:-top-1
    md:right-7
    lg:-top-1
    lg:right-2

    w-8
    md:w-12
    lg:w-16

    opacity-80
    pointer-events-none
  "
            />
            <img
              src={commaImage}
              alt=""
              className="
    absolute

    -top-1
    right-3

    sm:top-6
    sm:right-6

	md:-top-1
    md:right-20

    lg:-top-1
    lg:right-20

    w-8
    md:w-12
    lg:w-16

    opacity-80
    pointer-events-none
  "
            />

            {/* Content */}
            <div
              className="
    relative
    z-10

    flex-1
    overflow-hidden
  "
            >
              <AnimatePresence mode="wait">
                <motion.p
                  key={activeIndex}
                  initial={{
                    opacity: 0,
                    y: 30,
                  }}
                  animate={{
                    opacity: 1,
                    y: 0,
                  }}
                  exit={{
                    opacity: 0,
                    y: -30,
                  }}
                  transition={{
                    duration: 0.45,
                  }}
                  className="
        font-jakarta

        text-[15px]
        sm:text-[15px]
        lg:text-[19px]

        leading-[1.9]

        text-[#0C0200]
      "
                >
                  {testimonials[activeIndex].review}
                </motion.p>
              </AnimatePresence>
            </div>

            {/* Author */}

            <AnimatePresence mode="wait">
              <motion.div
                key={`author-${activeIndex}`}
                initial={{
                  opacity: 0,
                  y: 20,
                }}
                animate={{
                  opacity: 1,
                  y: 0,
                }}
                exit={{
                  opacity: 0,
                  y: -20,
                }}
                transition={{
                  duration: 0.4,
                }}
                className="
  mt-auto
  pt-4
"
              >
                <h4
                  className="
        font-prompt
        font-bold
        text-[20px]
        text-[#0C0200]
      "
                >
                  {testimonials[activeIndex].name}
                </h4>

                <p
                  className="
        mt-1
        text-[#0C0200]
        text-[16px]
        font-jakarta
      "
                >
                  {testimonials[activeIndex].role}
                </p>
              </motion.div>
            </AnimatePresence>

            {/* Rating */}

            <div
              className="
		mt-7
		flex
		justify-end
	"
            >
              <img src={starRating} alt="rating" className="w-[830px]" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
